import { PLACEHOLDER_MODULES } from '../features/modules/module-registry'

/**
 * Human section name for a pathname.
 *
 * One implementation, used by both the header bar (visible label) and the
 * route announcer (`document.title`), so the two cannot drift.
 *
 * Module titles come from the registry. Detail routes resolve to their
 * section, not the record - the record identifier belongs in the page, not
 * in permanent chrome or the window title (a browser tab title is
 * surfaced in history, session restore and screen-share; a customer
 * account number does not belong there).
 */
export function sectionTitle(pathname: string): string {
  if (pathname.startsWith('/members')) return 'Members'

  const module = PLACEHOLDER_MODULES.find(
    (m) => pathname === m.route || pathname.startsWith(`${m.route}/`),
  )
  if (module) return module.title

  if (pathname.startsWith('/sign-in')) return 'Sign in'
  if (pathname.startsWith('/sign-out')) return 'Sign out'
  if (pathname.startsWith('/access-denied')) return 'Access denied'
  if (pathname.startsWith('/error')) return 'Error'
  return 'Not found'
}

/** Window title for a pathname, per the MUR "Design Tokens and Accessibility" page (announcements). */
export function documentTitle(pathname: string): string {
  if (pathname === '/') return 'Murmuration'
  return `Murmuration - ${sectionTitle(pathname)}`
}
